import { useState } from 'react';
import { cn } from '@/lib/utils';
import { Image } from "@/components/common/image";
import { ChevronRightFillIcon } from "../agent-creation/assets/chevron-right-fill-icon";
import { ImageHoverPreview } from "../common/image-hover-preview";

interface ImageStackProps {
  images: string[];
  isFontEndFrameImage?: boolean;
}

const ImageStack: React.FC<ImageStackProps> = ({ images, isFontEndFrameImage }) => {
  const [hovered, setHovered] = useState(false);
  const count = images.length;
  if (count === 0) return null;

  const showArrow = count >= 2;
  // 堆叠区域尺寸（不含 margin）：单图 24x24，双图 36x36（第二张偏移12px）
  const stackWidth = count >= 2 ? 36 : 24;

  return (
    <div
      className={cn(
        "group relative inline-flex items-center bg-[rgba(234,236,240,1)] rounded-[4px] cursor-pointer",
        hovered && 'bg-white'
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className="relative m-px"
        style={{ width: stackWidth, height: 24 }}
      >
        {/* 常态堆叠（最多两张）淡出 */}
        <div className="absolute inset-0 transition-opacity duration-500 group-hover:opacity-0">
          {images.slice(0, 2).map((src, index) => (
            <div
              key={index}
              className={cn(
                "absolute w-6 h-6 rounded-[4px] overflow-hidden shadow-sm",
                index === 0 && 'border-r border-[rgb(234,236,240,1)]'
              )}
              style={{
                left: index * 12,
                zIndex: 2 - index,
              }}
            >
              <Image src={src} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>

        {/* 展开状态：水平排列，淡入 */}
        <div className="absolute left-0 top-0 flex items-center gap-1 p-0 rounded-[4px] opacity-0 invisible transition-all duration-500 group-hover:opacity-100 group-hover:visible z-50">
          {images.map((src, index) => (
            <div
              key={index}
              className="w-6 h-6 rounded-[4px] overflow-hidden hover:scale-125 transition-transform"
            >
              <ImageHoverPreview
                // className="w-[155px] h-[268px]"
                sideOffset={4}
                url={src}
                tag={isFontEndFrameImage ? index === 0 ? '首帧' : '尾帧' : ''}
              >
                <Image src={src} className="w-full h-full object-cover border border-[rgb(234,236,240,1)] " />
              </ImageHoverPreview>
            </div>
          ))}
        </div>
      </div>

      {/* 右箭头：图片 ≥ 2 时显示，垂直居中 */}
      {showArrow && (
        <ChevronRightFillIcon className="mx-1 text-[rgba(102,112,133,1)]" />
      )}
    </div>
  );
};

export default ImageStack;